import { webSocket, ISocketLogger, SleepModeDetector, IChannelTransport, IChannelTransportFactory } from "geotab-web-sockets";

export default class WebSocketFactory implements IChannelTransportFactory {
    private currentTransport: IChannelTransport | null = null;

    constructor(private readonly host: string, private readonly logger?: ISocketLogger) {}

    getConnection() {
        if (!this.currentTransport) {
            this.currentTransport = webSocket(this.host, new SleepModeDetector(this.logger), this.logger);
        }
        return this.currentTransport;
    }
}